<template>
  <ion-page>
    <ion-content>
      <div class="container">
        <section>
          <h1>All set to lift-off</h1>
          <p>Your event is ready to publish</p>
          <ion-card @click="goToEvent()">
            <img
              alt="Silhouette of mountains"
              src="https://ionicframework.com/docs/img/demos/card-media.png"
            />
            <ion-card-header>
              <ion-card-title>{{ contextStore.event.name }}</ion-card-title>
              <ion-card-subtitle
                >{{ contextStore.event.start_date }} -
                {{ contextStore.event.end_date }}</ion-card-subtitle
              >
            </ion-card-header>

            <ion-card-content>
              Here's a small text description for the card content. Nothing
              more, nothing less.
            </ion-card-content>
          </ion-card>
        </section>
      </div>
    </ion-content>
    <ion-footer class="ion-padding">
      <div class="container">
        <section>
          <ion-button expand="block" color="dark" @click="goToEvent()">
            <ion-icon slot="start" :icon="arrowForward"></ion-icon>
            Go to event
          </ion-button>
        </section>
      </div>
    </ion-footer>
  </ion-page>
</template>

<script setup lang="ts">
import { arrowForward } from "ionicons/icons";
import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonIcon,
  IonPage,
  IonContent,
  useIonRouter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";

const router = useIonRouter();
const contextStore = useContextStore();

const goToEvent = () => {
  router.push(`/event/${contextStore.event.id}/home`);
};
</script>
